module.exports = [
    {
        id: 'sunset',
        swatch: 'F76B1D',
    },
    {
        id: 'evergreen',
        swatch: '34731A',
    },
    {
        id: 'true_blue',
        swatch: '305B90',
    },
    {
        id: 'prince',
        swatch: '6C45C4',
    },
    {
        id: 'grayscale',
        swatch: 'AEAEAE',
    },
]
